import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const tumblr = defineConnector({
  identifier: "tumblr",
  name: "Tumblr",
  tagLine: "Microblogging and social networking platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.tumblr\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your Tumblr API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Register an application at [Tumblr API](https://www.tumblr.com/oauth/apps) and complete the OAuth 2.0 flow to get an access token.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.tumblr.com/v2/user/info",
  },
});
